import React, { useEffect, useState } from 'react'
import { FaShieldAlt, FaBolt, FaRupeeSign, FaTools, FaHardHat } from "react-icons/fa";
import { get_features_section } from '../../api/Global';

const iconMap = {
  "shield-check": FaShieldAlt,
  "bolt": FaBolt,
  "currency-rupee": FaRupeeSign,
  "wrench-screwdriver": FaTools,
};

const Why_Orbitpay = () => {
  const [features, setFeatures] = useState([]);

  useEffect(() => {
    const loadFeatures = async () => {
      try {
        const response = await get_features_section();
        setFeatures(response?.data?.data?.features || []);
      } catch (error) {
        console.log("features error", error);
      }
    };
    loadFeatures();
  }, []);

  return (
    <div>
    <section class="relative">
        <div class="absolute inset-0 bg-neutral-950 left-0 right-0"></div>
        <div class="relative py-10 md:py-24 sm:py-32 overflow-hidden">
            <div class="mx-auto max-w-7xl px-6 lg:px-8">
                <div class="mx-auto max-w-2xl text-center mb-10">
                    <div
                        class="inline-flex items-center px-4 py-2 rounded-full bg-[#252b33] border border-amber-800/30 mb-4">
                        <span class="text-sm font-medium text-amber-400">Why customers trust our utility team</span>
                    </div>
                    <h2 class="text-3xl text-white font-bold tracking-tight sm:text-4xl"><span class="sm:inline md:inline">Why
                            Build with Orbitpay?</span></h2>
                </div>
                <div class="relative">
                    <div class="px-4 -mx-4 md:px-0 md:mx-0">
                        <div class="flex transition-transform duration-500 ease-out">
                            <div class="w-full flex-shrink-0 px-4 md:px-0">
                                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
                                    {(features?.length ? features : [
                                      {
                                        id: "fallback-1",
                                        title: "Verified Service Technicians",
                                        description: "Trained and background-verified team for safe AC and utility work.",
                                        icon: "shield-check",
                                      },
                                      {
                                        id: "fallback-2",
                                        title: "Fast Doorstep Response",
                                        description: "Quick technician dispatch for urgent AC and utility breakdowns.",
                                        icon: "bolt",
                                      },
                                      {
                                        id: "fallback-3",
                                        title: "Transparent Pricing",
                                        description: "Clear estimate before work starts with no hidden charges.",
                                        icon: "currency-rupee",
                                      },
                                      {
                                        id: "fallback-4",
                                        title: "Multi-Service Support",
                                        description: "Single platform for AC repair, electrical and plumbing services.",
                                        icon: "wrench-screwdriver",
                                      },
                                    ]).map((feature) => {
                                      const Icon = iconMap[feature?.icon] || FaHardHat;
                                      return (
                                        <div key={feature.id} class="relative group md:transform-none">
                                            <div class="relative text-center backdrop-blur-xl bg-gray-900/50 rounded-xl p-6 h-full border border-amber-900/10 hover:border-amber-800/50 transition-colors duration-300">
                                                <div class="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-r from-amber-700 to-amber-500 text-white shadow-md shadow-amber-900/30">
                                                    <Icon size={24} />
                                                </div>
                                                <h4 class="text-white hover:text-amber-700 font-semibold">{feature?.title}</h4>
                                                <p class="mt-2 text-sm text-stone-300">{feature?.description}</p>
                                            </div>
                                        </div>
                                      );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Why sokumi end --> */}

    </div>
  )
}

export default Why_Orbitpay
